module.exports = __webpack_public_path__ + "7d80c8b3b30db7d09a8df72c950ea1d1.svg";